(function() {
  "use strict";
  angular.module("marketPlace.cart", []);
})();
